import { connectHook } from 'app/common/components/connect-hook';
import { NavItemLink } from './nav-item-link';
import { useNavItemLink } from './nav-item-link-hook';

export default connectHook(NavItemLink, useNavItemLink);
